export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.10-1355.23",
  commitId: "e200842e6ec3712fd1cc7216d77ede738de50f5d",
  commitTime: "2026-07-10T13:55:23.000Z",
});
